module.exports = __webpack_public_path__ + "img/empty-queue.c611e984.svg";